import loadScript from 'utils/loadScript.ts';
import { getAppProp } from 'utils/props';

const DATADOG_SCRIPT_URL =
  'https://www.datadoghq-browser-agent.com/eu1/v5/datadog-rum.js';

export async function initDatadog(): Promise<void> {
  if (typeof window === 'undefined') return;

  const env = getAppProp('env');
  if (['test', 'local'].includes(env)) return;

  if (document.querySelector(`script[src="${DATADOG_SCRIPT_URL}"]`)) return;

  const sampleRate = env === 'stage1' ? 100 : 1;

  try {
    await loadScript(DATADOG_SCRIPT_URL);

    window.DD_RUM?.onReady(() => {
      window.DD_RUM?.init({
        applicationId: 'db860996-83be-44a5-bcb1-34ab075743ca',
        clientToken: 'pub55b965804d56906bb7e680c0e44ca709',
        site: 'datadoghq.eu',
        service: 'yellow',
        env,
        // @ts-ignore
        version: getAppProp('commit_version'),
        sessionSampleRate: sampleRate,
        sessionReplaySampleRate: sampleRate,
        defaultPrivacyLevel: 'mask-user-input',
        plugins: [],
      });
    });
  } catch (err) {
    console.error('Failed to load Datadog RUM script:', err);
  }
}
